import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OverviewSection } from "./OverviewSection";
import { TestProgress } from "@/components/dashboard/TestProgress";
import { TestResultsList } from "./TestResultsList";
import { MilestonesSection } from "./MilestonesSection";
import { TestingModulesSection } from "./TestingModulesSection";

interface DesktopTabsProps {
  childId: string;
}

export const DesktopTabs = ({ childId }: DesktopTabsProps) => {
  return (
    <Tabs defaultValue="overview" className="w-full">
      <div className="border rounded-lg p-1 mb-6">
        <TabsList className="w-full flex justify-start gap-1">
          <TabsTrigger value="overview" className="flex-1">Overview</TabsTrigger>
          <TabsTrigger value="progress" className="flex-1">Progress</TabsTrigger>
          <TabsTrigger value="testing-modules" className="flex-1">Testing Modules</TabsTrigger>
          <TabsTrigger value="tests" className="flex-1">Test Results</TabsTrigger>
          <TabsTrigger value="milestones" className="flex-1">Milestones</TabsTrigger>
        </TabsList>
      </div>
      <TabsContent value="overview">
        <OverviewSection />
      </TabsContent>
      <TabsContent value="progress">
        <TestProgress childId={childId} />
      </TabsContent>
      <TabsContent value="testing-modules">
        <TestingModulesSection childId={childId} />
      </TabsContent>
      <TabsContent value="tests">
        <Card>
          <CardContent className="p-6">
            <TestResultsList childId={childId} />
          </CardContent>
        </Card>
      </TabsContent>
      <TabsContent value="milestones">
        <MilestonesSection childId={childId} />
      </TabsContent>
    </Tabs>
  );
};